import React from 'react';
import PropTypes from 'prop-types';
import { ContextMenuWrapper, useContextMenuTrigger } from 'react-context-menu-wrapper';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => {
  const { palette } = theme;
  return {
    root: {
      backgroundColor: palette.white,
      border: `1px solid ${palette.grey.medium}`,
      borderRadius: '6px',
      boxShadow: `1px 1px 5px 0px ${palette.grey.medium}`,
      zIndex: '1000',
      position: 'absolute',
      padding: '10px',
      minWidth: '200px',
      width: 'max-content'
    }
  };
});

export const ContextMenu = ({
  children,
  menuId,
  menuComponent,
  hideOnOutsideClick,
  hideOnSelfClick
}) => {
  const ref = useContextMenuTrigger({ menuId });
  const classes = useStyles();
  return (
    <>
      <div ref={ref}>{children}</div>
      <ContextMenuWrapper
        id={menuId}
        hideOnOutsideClick={hideOnOutsideClick}
        hideOnSelfClick={hideOnSelfClick}
      >
        <div className={classes.root}>{menuComponent}</div>
      </ContextMenuWrapper>
    </>
  );
};

ContextMenu.propTypes = {
  children: PropTypes.node.isRequired,
  menuId: PropTypes.string.isRequired,
  menuComponent: PropTypes.node.isRequired,
  hideOnSelfClick: PropTypes.bool,
  hideOnOutsideClick: PropTypes.bool
};

ContextMenu.defaultProps = {
  hideOnSelfClick: false,
  hideOnOutsideClick: true
};

export default ContextMenu;
